import { Button } from "./button";
import { parseFormat } from "@util/date";
import { getApplicationStatusClass } from "@util/string";
import { HireResponse } from "@type/contract";
import { useNavigate } from "react-router-dom";
import { FileIcon } from "lucide-react";

interface Props {
    candidate: HireResponse
}

export default function CandidateHireItem({ candidate }: Props) {
    const navigate = useNavigate();
    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div className="flex justify-between">
                <div className="flex items-center">
                    <div className="h-12 w-12 rounded-full overflow-hidden mr-3">
                        <img
                            onError={(e) => {
                                e.currentTarget.src = `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/default_avatar.png`;
                                e.currentTarget.onerror = null; // Prevent infinite loop
                            }}
                            src={`${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/${candidate.profile_picture_path}`}
                            alt={candidate.job_seeker_name}
                            className="h-full w-full object-cover"
                        />
                    </div>

                    <div>
                        <h3 className="text-base font-medium text-gray-900 dark:text-white">
                            {candidate.job_seeker_name}
                        </h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            {candidate.job_title}
                        </p>
                    </div>
                </div>
                <span className={`text-xs font-medium px-2 py-1 rounded-full h-fit ${getApplicationStatusClass(candidate.status)}`}>
                    {candidate.status}
                </span>
            </div>
            <div className="mt-4 space-y-2">
                <div className="flex justify-between">
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Department
                    </span>
                    <span className="text-sm text-gray-900 dark:text-white">
                        {candidate.department}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Work Option
                    </span>
                    <span className="text-sm text-gray-900 dark:text-white">
                        {candidate.work_option}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Start Date
                    </span>
                    <span className="text-sm text-gray-900 dark:text-white">
                        {parseFormat(candidate.start_date, "D MMMM YYYY")}
                    </span>
                </div>
                {candidate.end_date && (
                    <div className="flex justify-between">
                        <span className="text-sm text-gray-500 dark:text-gray-400">
                            End Date
                        </span>
                        <span className="text-sm text-gray-900 dark:text-white">
                            {parseFormat(candidate.end_date, "D MMMM YYYY")}
                        </span>
                    </div>
                )}
            </div>
            <div className="mt-4 flex flex-row space-x-2">
                <Button
                    variant="outline"
                    className="flex-1 text-sm"
                    onClick={() => navigate(`/candidate/${candidate.cv_id}`)}
                >
                    View Profile
                </Button>
                {!!candidate.signed_contract_s3 && (
                    <Button
                        variant="outline"
                        onClick={() => {
                            window.open(`${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/${candidate.signed_contract_s3}`);
                        }}
                    >
                        <FileIcon />
                    </Button>
                )}
            </div>
        </div>
    )
}